import type { Member } from '@/features/iam/members/Member'
import type { UserData } from '@/features/iam/users/UserData'
import { env } from '@/infra/env'
import { PostHogTrackingService } from './PostHogTrackingService'
import { NoOpTrackingService } from './NoOpTrackingService'

/**
 * Identifies the user for session recording, and clears the session on
 * logout.
 */
export interface TrackingService {
  /**
   * Links the member to the current session.
   *
   * @param member
   * @param userData
   */
  identify(member: Member, userData: UserData): void

  /**
   * Clears the session, such as on logout.
   */
  reset(): void
}

/**
 * Creates the PostHog tracking service when configured.
 */
export function createTrackingService(): TrackingService {
  return env.POSTHOG_KEY
    ? PostHogTrackingService.create()
    : NoOpTrackingService.create()
}
